import { ProjectJira } from '../models/ProjectJira';
export class ProjectJiraMapper {
  mapGQLModel(data: any): ProjectJira {
    return new ProjectJira(data.projectKey, data.issueTypeKey, data.issueCollectorCode);
  }
}
